import { AbstractControl, FormGroup } from '@angular/forms';

export function PasswordMatch(
  group: AbstractControl,
): null | { passwordsMatch: boolean } {
  const password1 = group.get('newPassword').value;
  const password2 = group.get('newPassword2').value;

  return password1 === password2 ? null : { passwordsMatch: false };
}
